import { Component, OnInit } from '@angular/core';
import { ServicioFirebaseService } from 'src/app/servicios/servicio-firebase.service';
///variable de jquey para modal//
declare var $: any;

@Component({
  selector: 'app-registrousuario',
  templateUrl: './registrousuario.component.html',
  styleUrls: ['./registrousuario.component.css']
})
export class RegistrousuarioComponent implements OnInit {
  public email: string = "";
  public contra: string = "";
  public nombre: string = "";
  public apellidoM: string = "";
  public apellidoP: string = "";
  public institucion: string = "";
  public plan: string = "";
  public tarjeta: string = "";
  public datosIncompletos:boolean=false;
  constructor(private serivico: ServicioFirebaseService) { }
  ngOnInit() {
  }
  async registrarUsuario() {
    if (this.email != "" && this.contra != "" && this.nombre != "" && this.apellidoM != "" && this.apellidoP != "" && this.institucion != "" && this.plan != "" && this.tarjeta != "") {
     await this.serivico.registrarUsuarioCorreo(this.email, this.contra, this.nombre, this.apellidoP, this.apellidoM, this.institucion, this.plan, this.tarjeta);
      this.showModal();
    }else{
      this.datosIncompletos=true;
      this.showModal();
    }
  }
  showModal(): void {
    $("#myModal").modal('show');
  }
}